/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Source_LocaleInputs */

const cs_property_ai_source_locale = /** @type {(inputs: Property_Ai_Source_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z jazyka`)
};

const en_property_ai_source_locale = /** @type {(inputs: Property_Ai_Source_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From language`)
};

/**
* | output |
* | --- |
* | "From language" |
*
* @param {Property_Ai_Source_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_source_locale = /** @type {((inputs?: Property_Ai_Source_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Source_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_source_locale(inputs)
	return cs_property_ai_source_locale(inputs)
});